export default __webpack_public_path__ + "static/media/playerLogo.aa80cc24.svg";